import { useEffect } from "react"
import { WeeklyCalculatorProvider } from "./WeeklyCalculatorProvider"
import { WeeklyCalculatorForm } from "./components/WeeklyCalculatorForm"
import { StatisticsPanel } from "@/shared/components/statistics"
import { WeeklyResultsCard } from "./components/WeeklyResultsCard"
import { useWeeklyCalculator } from "./useWeeklyCalculator"

function WeeklyPageContent() {
  const {
    advancedOpen,
    formErrors,
    formValues,
    handleFieldChange,
    handleSubmit,
    result,
    resultsVisible,
    status,
    toggleAdvanced,
  } = useWeeklyCalculator()

  useEffect(() => {
    if (!resultsVisible || status !== "complete") {
      return
    }

    const resultsSection = document.getElementById("results")
    if (resultsSection instanceof HTMLElement) {
      resultsSection.scrollIntoView({ behavior: "smooth", block: "start" })

      const heading = document.getElementById("results-heading")
      if (heading instanceof HTMLElement) {
        heading.focus({ preventScroll: true })
      }
    }
  }, [resultsVisible, status, result])

  return (
    <div className="mx-auto flex w-full flex-col gap-10 pr-2">
      <div className="grid gap-8 lg:grid-cols-[minmax(0,1.8fr)_minmax(0,1fr)]">
        <div className="stack-lg" id="weekly-calculator-form">
          <WeeklyCalculatorForm
            advancedOpen={advancedOpen}
            errors={formErrors}
            isCalculating={status === "calculating"}
            onFieldChange={handleFieldChange}
            onSubmit={handleSubmit}
            onToggleAdvanced={toggleAdvanced}
            values={formValues}
          />
        </div>

        <StatisticsPanel className="lg:sticky lg:top-10" />
      </div>

      {resultsVisible ? (
        <section className="stack-lg pb-16" id="results">
          <WeeklyResultsCard result={result} status={status} formValues={formValues} />
        </section>
      ) : null}
    </div>
  )
}

export default function WeeklyPage() {
  return (
    <WeeklyCalculatorProvider>
      <WeeklyPageContent />
    </WeeklyCalculatorProvider>
  )
}
